import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import ManageCredentialsModal from 'zComponents/molecules/ManageCredentialsModal';

import { Button, Col, Row, Tooltip } from 'zui/Antd';

const CredentialPanelExtra = ({ personID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canAddCredential = useManagePermittedRoles('addCredential');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canAddCredential) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('credentials')) {
			setActiveKeys([...activeKeys, 'credentials']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('credentials')) {
					return [...prev, 'credentials'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canAddCredential ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canAddCredential}
						/>
					</span>
				</Tooltip>
			</Col>
			<ManageCredentialsModal visible={openModal} setVisible={handleCloseModal} personID={personID}>
				<div />
			</ManageCredentialsModal>
		</Row>
	);
};

export default CredentialPanelExtra;
